<div class="c-portlet__content pos-relative" style="height: 610px" (window:resize)="onResize($event)">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div id="geofence-disclaimer" class="geofence-disclaimer">
		<div class="geofence-disclaimer-section">
			<img class="geofence-disclaimer-img" src="../../../../../../assets/images/info-circle.png" />
			<span class="geofence-disclaimer-text"
				>Geofence/geo recency points may not display due to category-specific privacy restrictions in a selected
				campaign.</span
			>
		</div>
	</div>
	<div>
		<div class="map-wrapper">
			<div id="map"></div>
			<div id="info" class="info"></div>

			<div class="r6-map-details-container">
				<div id="deatails" class="deatails">
					<ul class="info-list">
						<li>
							<p class="address">{{ geoFenceCenterAddress }}</p>
						</li>
						<li class="imprs">
							<b class="geo-title">IMPRS</b
							><span class="geo-values">{{
								geofenceCenterDetails?.total_impression_sum ? (geofenceCenterDetails?.total_impression_sum | number) : 0
							}}</span>
						</li>
						<li class="clicks">
							<b class="geo-title">CLICKS</b
							><span class="geo-values">{{
								geofenceCenterDetails?.total_click_sum ? (geofenceCenterDetails?.total_click_sum | number) : 0
							}}</span>
						</li>
						<li class="ctr">
							<b class="geo-title">CTR</b
							><span class="geo-values"
								>{{
									geofenceCenterDetails?.click_through_rate
										? (geofenceCenterDetails?.click_through_rate | number : '1.2-2')
										: 0.0
								}}%</span
							>
						</li>
						<li class="ios">
							<b><img class="geo-title" src="../../../../../assets/images/apple.png" /></b
							><span class="geo-values"
								>{{
									geofenceCenterDetails?.total_ios ? (geofenceCenterDetails?.total_ios | number : '1.2-2') : 0.0
								}}%</span
							>
						</li>
						<li class="andr">
							<b><img class="geo-title" src="../../../../../assets/images/android.png" /></b
							><span class="geo-values"
								>{{
									geofenceCenterDetails?.total_android
										? (geofenceCenterDetails?.total_android | number : '1.2-2')
										: 0.0
								}}%</span
							>
						</li>
					</ul>
				</div>
			</div>
			<div class="impression-gradient" [ngClass]="{ noGeofence: !showGeofenceLegends }" *ngIf="!isDOOH">
				<label>IMPRESSIONS</label>
				<div class="gradient">
					<div class="less">less</div>
					<div class="item" [ngStyle]="{ opacity: x }" *ngFor="let x of [0.3, 0.4, 0.5, 0.6, 0.7]"></div>
					<div class="more">more</div>
				</div>
			</div>
			<div class="geoCenters-info" *ngIf="showGeofenceLegends">
				<div class="geoCenters-div geofence-div">
					<div class="geo-dot"></div>
					<div class="geo-values">GeoFence</div>
				</div>
				<div class="geoCenters-div">
					<div class="recency-dot"></div>
					<div class="geo-values">Retargeting</div>
				</div>
			</div>
		</div>

		<!-- LIft Detail Container-->
		<div>
			<div class="map-region-lift-detail-container" *ngIf="!noData">
				<table class="ovw-sub-table" *ngIf="polygonLayerDetails.showLift">
					<tr class="ovw-header">
						<th class="first-title">Home Value</th>
						<th>Income</th>
						<th>Postal Code</th>
						<th>Lift</th>
					</tr>
					<tr>
						<td>
							<span *ngIf="polygonLayerDetails.avgHomeValue" class="map-region-dmographic-value"
								>${{ polygonLayerDetails.avgHomeValue | formatNumber }}</span
							>
							<span *ngIf="!polygonLayerDetails.avgHomeValue" class="map-region-dmographic-value">N/A</span>
						</td>
						<td class="income-td">
							<span *ngIf="polygonLayerDetails.avgIncome" class="map-region-dmographic-value"
								>${{ polygonLayerDetails.avgIncome | formatNumber }}</span
							>
							<span *ngIf="!polygonLayerDetails.avgIncome" class="map-region-dmographic-value">N/A</span>
						</td>
						<td class="zip-td">
							<span *ngIf="polygonLayerDetails.zip" class="map-region-dmographic-value">{{
								polygonLayerDetails.zip
							}}</span>
							<span *ngIf="!polygonLayerDetails.zip" class="map-region-dmographic-value">N/A</span>
						</td>
						<td class="lift-td">
							<span *ngIf="polygonLayerDetails.avgLift" class="map-region-dmographic-value"
								>{{ polygonLayerDetails.avgLift }}x</span
							>
							<span *ngIf="!polygonLayerDetails.avgLift" class="map-region-dmographic-value">N/A</span>
						</td>
					</tr>
				</table>
				<div *ngIf="!polygonLayerDetails.showLift">
					<div class="no-lift-data">No Lift Data</div>
				</div>
				<!-- Show Lift -->
			</div>
		</div>

		<!-- LIft Detail Container-->
		<div class="map-region-container dooh" *ngIf="isDOOH">
			<div class="header_controllers">
				<div class="selected-count">{{ doohGeoRecencyData?.features?.length }} Selected</div>
				<div class="action-links">
					<a
						href="javascript:void(0);"
						(click)="selectAll()"
						[class.disabledBtn]="doohGeoRecencyData?.features?.length === doohData?.features?.length"
						>Select All</a
					>
					<a
						href="javascript:void(0);"
						(click)="clearAll()"
						[class.disabledBtn]="doohGeoRecencyData?.features?.length === 0"
						>Clear All</a
					>
				</div>
			</div>
			<div *ngFor="let feature of doohData?.features; trackBy: trackByRegionId" class="map-region-details">
				<div class="map-region-detail-container">
					<input
						type="checkbox"
						[id]="feature.properties.id"
						[(ngModel)]="selectedItems[feature.properties.id]"
						(change)="onCheckboxChange($event, feature)"
						class="styled-checkbox"
					/>
					<span class="checkmark"></span>
					<label [for]="feature.properties.id">
						<span class="dot" [ngStyle]="{ 'background-color': feature.properties.venue_color }"></span>
						<span class="venue_name">{{ feature.properties.venue_type_1 }}</span>
					</label>
				</div>
			</div>
		</div>
		<div class="zoom-options-container">
			<div>
				<button class="zoom-icon zoom-in" (click)="zoomIn()">+</button>
			</div>
			<div>
				<button class="zoom-icon zoom-out" style="border-top: 0px" (click)="zoomOut()">-</button>
			</div>
		</div>
		<div class="no-data-container" style="height: 610px" *ngIf="noData">
			<div class="map-no-data no-data-text">No Data available</div>
		</div>
	</div>
</div>
